<template>
  <div class="contaniorn">
    <div >
      <img class="img" style="height: 4px;width: 100%" src="../../static/img/t-bar.jpg" alt="">
    </div>
    <div class="footer">
      <div class="footer_nav">
        <p style="padding-bottom: 14px">
          <a href="/">网站首页</a> |
          <a @click="topscoll()" href="#/ProRecommend">开心玩国</a> |
          <a @click="topscoll()" href="#/le">创新产品</a> |
          <a @click="topscoll()" href="#/add">财富世界</a> |
          <a @click="topscoll()" href="#/Joinus">加入我们</a> |
          <a @click="topscoll()" href="#/newadd">新闻资讯</a> |
          <a @click="topscoll()" href="#/contactus">联系方式</a></p>
        <div style="height: 135px">
          <div class="footer_left">
            <p>免费热线：400-0616-123</p>
            <p>国家商务部商业特许经营备案连锁企业 备案号：0110800311500169</p>
            <p>中国商务部国家级重点信用认证企业 信用编码：BCP24404856</p>
            <p>中关村高新技术企业 编码：20162010123201</p>
          </div>
          <div class="footer_right">
            <p>北京地址：北京市房山区天星街1号院绿地启航国际15号楼18楼</p>
            <p>湖北地址：湖北省武汉市东西湖大道与孝武大道交汇处509号</p>
            <p>成都地址：四川省成都市金牛区金科南路169号1栋9号905室</p>
          </div>
        </div>
        <div class="footer-bottom text-center">

          <span>友情链接：</span>

          <p class="footer-link" v-for="item in data" >


            <a :href="item.link" target="_blank">{{item.title}}</a>



          </p>

        </div>
        <div class="footer_bottom">
        开心玩国儿童乐园  Beijing Happy-Hale Education Technology Co.,Ltd <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #939393;">鄂ICP备2022004408号</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Prohead',
  data () {
    return {
      changeRed:0,
      data:''
    }
  },
  created() {
    this.you()
  },
  mounted() {

  },
  methods:{
    you(id,name){
      console.log(id)
      this.curs = name
      let formdata = {
        cate_id:id
      }
      this.$axios.post('/index/links/linksList',formdata).then(res => {
        this.data=res.data.data


      });
    },
    topscoll(){
      console.log('1123123')
      window,scrollTo(0,0);
    },
    reds:function(index){
      console.log(index)
      this.changeRed = index;
    }
  }
}
</script>

<style scoped>
.footer-link {
  display: inline-block;
}
.footer-link a:after {
  content: " |";
}
.footer-bottom a {
  color: #999;
  transition: linear .2s color;
  -webkit-transition: linear .2s color;
}
.footer-bottom {
  background: #2d1b4c;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 10px;

  font-size: 14px;
}
.text-center {
  text-align: center;
}
.footer_nav a{
  color: #ffffff;
  cursor: pointer;
}
.footer_bottom{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #939393;
  text-align: center;
}
.footer_left{
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #CCCCCC;
  line-height: 28px;
  height: 99px;

}
.footer_right{
  float: right;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #CCCCCC;
  line-height: 28px;
  height: 99px;
}
.footer{
  //width: 100%;
  //height: 273px;
  background: #1D0F35;
  margin-top: -5px;
}
.footer_nav{
  width: 1300px;
  margin: 0 auto;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 28px;
  padding-top: 47px;
  padding-top: 30px;
}
.red{
  color: #DF584D;
  border-bottom: 5px solid #DF584D;
}
.nav {
  line-height: 120px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
  text-align: center;
}
.contaniorn{
  //background: #ffffff;
}
.header{
  height: 120px;
  width: 1300px;
  margin: 0 auto;
}
.header_img{
  width: 400px;
  float: left;
}
.header_img img{
  margin-top: 25px;
}
.header_nav{
  float: left;
}
.header_nav ul li{
  float: left;
  width: 120px;
  height: 120px;

}
</style>



// WEBPACK FOOTER //
// src/components/Profooter.vue